import moment from 'moment-timezone'
import jsonToFormData from 'json-form-data'

export function isOwnProperty(obj, objKey) {
  return Object.prototype.hasOwnProperty.call(obj, objKey)
}

export async function waitForReadyState() {
  if (
    typeof document !== 'undefined' &&
    typeof window !== 'undefined' &&
    document.readyState !== 'complete'
  ) {
    await new Promise((resolve) => {
      const cb = () => {
        window.requestAnimationFrame(resolve)
        window.removeEventListener('load', cb)
      }

      window.addEventListener('load', cb)
    })
  }
}

export function toQueryString(initialObj) {
  const reducer = (obj, parentPrefix = null) => (prev, key) => {
    const val = obj[key]
    key = encodeURIComponent(key)
    const prefix = parentPrefix ? `${parentPrefix}[${key}]` : key

    if (val == null || typeof val === 'function') {
      prev.push(`${prefix}=`)
      return prev
    }

    if (['number', 'boolean', 'string'].includes(typeof val)) {
      prev.push(`${prefix}=${encodeURIComponent(val)}`)
      return prev
    }

    prev.push(Object.keys(val).reduce(reducer(val, prefix), []).join('&'))
    return prev
  }

  return Object.keys(initialObj).reduce(reducer(initialObj), []).join('&')
}

export function newFormData(obj, options = {}) {
  return jsonToFormData(obj, options)
}

/**
 * Convert date, time to timezone local
 * @type {string}
 *
 * date = yyyy-mm-dd
 * datetime = yyyy-mm-dd hh:ii:ss
 */
export function utcToLocal(datetime, format, defaultString = '') {
  return datetime
    ? moment(datetime).utc().local().format(format)
    : defaultString
}

export function datetimeNow(format) {
  return moment().format(format)
}

export function utcToLocalDateTimeLess(datetime, defaultString = '') {
  return utcToLocal(datetime, 'DD/MM/YYYY HH:mm', defaultString)
}

export function dateFormat(
  date,
  toFormat = 'DD/MM/YYYY',
  defaultString = ''
) {
  return date ? moment(date).format(toFormat) : defaultString
}

export function requestGet(key = null) {
  const request = new URLSearchParams(location.search)
  return key !== null ? request.get(key) : request
}

export function isDueDate(dateString) {
  const todayDate = moment().startOf('day')
  const dateChecking = moment(dateString).startOf('day')
  return dateChecking.isBefore(todayDate)
}

export function isOverDueTask(task) {
  if (!task.due_date) {
    return false
  }
  return isDueDate(task.due_date) && ['pending', 'in_progress'].includes(task.status)
}

export function parseHtmlEntities(str) {
  if (str === null) {
    return null
  }
  const txt = document.createElement('textarea')
  txt.innerHTML = str
  return txt.value
}

export function timeAgo(datetime, locale) {
  if (!datetime) {
    return null
  }
  moment.locale(locale)
  return moment(datetime).fromNow()
}
